import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout.tsx";
import { ProtectedRoute } from "./components/ProtectedRoute.tsx";
import { AuthProvider } from "./lib/auth-context.tsx";

const Dashboard = lazy(() => import("./pages/Dashboard.tsx"));
const Certificates = lazy(() => import("./pages/Certificates.tsx"));
const Invoices = lazy(() => import("./pages/Invoices.tsx"));
const EntityLookup = lazy(() => import("./pages/EntityLookup.tsx"));
const Logs = lazy(() => import("./pages/Logs.tsx"));
const Workflows = lazy(() => import("./pages/Workflows.tsx"));
const Settings = lazy(() => import("./pages/Settings.tsx"));
const Login = lazy(() => import("./pages/Login.tsx"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const LoadingFallback = () => (
  <div className="flex items-center justify-center h-64">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
  </div>
);

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/certificates" element={<Certificates />} />
                  <Route path="/invoices" element={<Invoices />} />
                  <Route path="/entities" element={<EntityLookup />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/workflows" element={<Workflows />} />
                  <Route path="/settings" element={<Settings />} />
                </Route>
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
